import DeliveryDetailInputPanel from "./deliveryDetailInputPanel.container";

export default DeliveryDetailInputPanel;
